var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"id":_vm.id,"value":_vm.value,"options":[
    { value: 'F', text: 'Factura' },
    { value: 'R', text: 'Abono' },
    { value: 'B', text: 'Borrador' },
    { value: 'BR', text: 'Borrador Abono' }
  ],"label":"text","reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }